import {
  BUILD,
  FINISHED_TO_ORDER,
  LEG,
  SIZES,
  SHORTSLEG,
  SWIMSHORTSLEG,
  TAPER,
  LOWER_LEG_SLIM_SHORT,
  LOWER_LEG_SLIM_LONG,
  LENGTH
} from '@consts/index'
import { ProductOption } from 'types/product'

function transformProductOptionsValues(
  type: string,
  values: ProductOption['values']
): string[] {
  if (type === LENGTH.toLowerCase()) {
    // ensure the length values are in the right order (using SIZES for reference)
    values.sort((a, b) => {
      const lengthReferenceArray = SIZES.length
      return lengthReferenceArray.indexOf(a) - lengthReferenceArray.indexOf(b)
    })
  }

  if (type === LEG.toLowerCase() && values.includes(FINISHED_TO_ORDER)) {
    return SIZES.leg as unknown as string[]
  }

  if (type === BUILD.toLowerCase()) {
    return values.map(value => value.replace('Build ', ''))
  }

  if (type === TAPER.toLowerCase()) {
    return [
      ...new Set(
        values.map(value => {
          return [LOWER_LEG_SLIM_SHORT, LOWER_LEG_SLIM_LONG].includes(value)
            ? 'Slim'
            : value
        })
      )
    ]
  }

  return values
}

function transformName(type: string, name: string) {
  if (
    type === SHORTSLEG.toLowerCase() ||
    type === SWIMSHORTSLEG.toLowerCase()
  ) {
    return 'Leg'
  }

  return name
}

export function transformProductOptions(options: ProductOption[]) {
  return options
    .filter(option => option.type !== 'taper')
    .map(option => {
      const name = transformName(option.type, option.name)
      return {
        ...option,
        name,
        values: transformProductOptionsValues(option.type, option.values)
      }
    })
}
